/**
 * Reset body scroll lock after Bootstrap modals fully exit.
 * Never removes `.modal-backdrop` nodes — React Bootstrap owns those and
 * calling `Element.remove()` on them causes removeChild NotFoundError / white screen.
 */
export function cleanupOrphanModalBackdrops() {
  if (
    document.querySelector('.modal.show') ||
    document.querySelector('.modal-backdrop')
  ) {
    return;
  }
  document.body.classList.remove('modal-open');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('padding-right');
}
